var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center align-middle py-3 py-md-5",attrs:{"data-test-id":"application-spinner-label"}},[_c('h3',{staticClass:"pb-3 pb-md-5"},[_vm._v(" "+_vm._s(_vm.defaultLabel)+" ")]),_c('b-spinner',{staticClass:"h-3rem w-3rem",attrs:{"variant":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }